import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

const FOOTER_FALLBACK = {
  email: "sendlewskaagnieszka@gmail.com",
  phone: "+48 606645781",
  sessions: "Online (cały świat)",
};

export default function Footer() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [contact, setContact] = useState(FOOTER_FALLBACK);

  useEffect(() => {
    api.get("/content")
      .then(({ data }) => { if (data?.footer) setContact({ ...FOOTER_FALLBACK, ...data.footer }); })
      .catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await api.post("/contact", { name, email, message });
      toast.success("Wiadomość wysłana. Odezwę się wkrótce.");
      setName(""); setEmail(""); setMessage("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Błąd wysyłki");
    } finally {
      setSending(false);
    }
  };

  return (
    <footer id="kontakt" className="bg-[#1F2421] text-[#E5E0D8] mt-32" data-testid="footer">
      <div className="container-prose py-20 md:py-28">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24">
          <div>
            <p className="text-overline text-[#8A9A86] mb-6">Kontakt</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-white leading-[1.05] mb-8">
              Napisz, jeśli czujesz, że to czas.
            </h2>
            <p className="text-[#C8CCC4] text-base md:text-lg font-light leading-relaxed max-w-md mb-12">
              Najlepiej zacząć od krótkiej, niezobowiązującej rozmowy. Odpisuję w ciągu 48 godzin.
            </p>
            <div className="space-y-4 text-sm">
              <div className="flex gap-4">
                <span className="text-[#8A9A86] uppercase tracking-widest w-24">Email</span>
                <span data-testid="footer-email">{contact.email}</span>
              </div>
              <div className="flex gap-4">
                <span className="text-[#8A9A86] uppercase tracking-widest w-24">Telefon</span>
                <span data-testid="footer-phone">{contact.phone}</span>
              </div>
              <div className="flex gap-4">
                <span className="text-[#8A9A86] uppercase tracking-widest w-24">Sesje</span>
                <span>{contact.sessions}</span>
              </div>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-6" data-testid="contact-form">
            <div>
              <label className="text-overline block mb-2">Imię</label>
              <input
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                data-testid="contact-name"
                className="w-full bg-transparent border-b border-[#3A413E] py-3 focus:outline-none focus:border-[#8A9A86] transition-colors text-white"
              />
            </div>
            <div>
              <label className="text-overline block mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="contact-email"
                className="w-full bg-transparent border-b border-[#3A413E] py-3 focus:outline-none focus:border-[#8A9A86] transition-colors text-white"
              />
            </div>
            <div>
              <label className="text-overline block mb-2">Wiadomość</label>
              <textarea
                required
                rows={4}
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                data-testid="contact-message"
                className="w-full bg-transparent border-b border-[#3A413E] py-3 focus:outline-none focus:border-[#8A9A86] transition-colors text-white resize-none"
              />
            </div>
            <button
              type="submit"
              disabled={sending}
              data-testid="contact-submit"
              className="bg-[#8A9A86] text-white rounded-full px-8 py-4 hover:bg-[#72826F] transition-colors duration-300 font-medium text-sm tracking-wide disabled:opacity-50"
            >
              {sending ? "Wysyłanie…" : "Wyślij wiadomość"}
            </button>
          </form>
        </div>

        <div className="mt-20 pt-8 border-t border-[#3A413E] flex flex-col md:flex-row justify-between gap-4 text-xs text-[#A0A89F]">
          <p>© {new Date().getFullYear()} Agnieszka Sendlewska. Wszelkie prawa zastrzeżone.</p>
          <div className="flex gap-6">
            <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-white transition-colors">Panel</Link>
            <span>Polityka prywatności</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
